import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  display: ', ';\n  position: absolute;\n  border: 2px solid ', ';\n  color: ', ';\n  background-color: ', ';\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  font-weight: 600;\n  right: 10px;\n  bottom: 10px;\n  z-index: 50;\n  padding: 10px 15px;\n  opacity: 0.7;\n\n  @media screen and (max-width: ', ') {\n    /* match thumbnail button */\n    right: 0;\n    bottom: auto;\n    top: 100%;\n    height: 12%;\n    max-height: 50px;\n    line-height: 0;\n    opacity: 1;\n  }\n'], ['\n  display: ', ';\n  position: absolute;\n  border: 2px solid ', ';\n  color: ', ';\n  background-color: ', ';\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  font-weight: 600;\n  right: 10px;\n  bottom: 10px;\n  z-index: 50;\n  padding: 10px 15px;\n  opacity: 0.7;\n\n  @media screen and (max-width: ', ') {\n    /* match thumbnail button */\n    right: 0;\n    bottom: auto;\n    top: 100%;\n    height: 12%;\n    max-height: 50px;\n    line-height: 0;\n    opacity: 1;\n  }\n']);

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

var StyledClearAllButton = styled.button(_templateObject, function (props) {
  return props.active ? 'block' : 'none';
}, function (props) {
  return props.theme.dormifyBlack;
}, function (props) {
  return props.theme.dormifyBlack;
}, function (props) {
  return props.theme.dormifyWhite;
}, function (props) {
  return props.theme.tabletWidth;
});

var VisualizerClearAllButton = function VisualizerClearAllButton(_ref) {
  var selectedProducts = _ref.selectedProducts,
      windowWidth = _ref.windowWidth,
      largeThumbnail = _ref.largeThumbnail,
      handleClearAll = _ref.handleClearAll;

  var handleClick = function handleClick(e) {
    // prevent double click since we are also clicking StyledVisualizerWrapper
    e.stopPropagation();
    handleClearAll();
  };

  if (selectedProducts.length > 0) {
    return React.createElement(
      StyledClearAllButton,
      {
        active: windowWidth > 769 || largeThumbnail,
        onClick: handleClick,
        'data-service-hide-element': 'true' // hide all modals when thumbnail servive is rendering pages
      },
      'Clear All'
    );
  } else {
    return null;
  }
};

VisualizerClearAllButton.propTypes = {
  selectedProducts: PropTypes.array.isRequired,
  largeThumbnail: PropTypes.bool.isRequired,
  windowWidth: PropTypes.number.isRequired,
  handleClearAll: PropTypes.func.isRequired
};

export default VisualizerClearAllButton;